/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const routes = {
  landing_page: "/",
  login: "/login",
  logout: "/logout",
  dashboard: "/dashboard",
  forgot_password_page: "/forgot-password",
  reset_password_page: "/resetpassword",
  reset_password_success: "/resetpasswordsuccess",
  user_mgmt_page: "/user-list",
  company_mgmt_page: "/company-list",
  reset_password_gen: "/resetpassword",
  create_pipe: "/create-pipe",
  edit_pipe: "/edit-pipe",
  view_pipe: "/view-pipe",
  admin_settings: "/billing-usage",
  change_password: "/change-password",
  collector_list: "/collector-list",
  connector_list: "/connector-list",
  datapipe_list: "/data-pipe-list",
  create_collector: "/create-collector",
  create_connector: "/create-connector",
  edit_collector: "/edit-collector",
  edit_connector: "/edit-connector",
  signup: "/signup",
  mediatailor_signup: "/mediatailor-signup",
  mediatailor_register: "/mediatailor-registration",
  complete_signup: "/complete-registration",
  pending_approval: "/pending-approval",
  rate_cards: "/rate-cards",
  payment: "/payment",
  delete_connector: "/delete-connector",
  delete_collector: "/delete-collector",
  delete_datapipe: "/delete-datapipe",
  data_dictionary: "/data-point-management",
  projects: "/projects",
  collectorConfiguration: "/collector-configuration",
  connectorConfiguration: "/connector-configuration",
  custom_data: "/custom-data",
  companies: "/companies",
  users: "/users",
  collector_management: "/collector-management",
  epg_enrichment: "/epg-enrichment",
  data_pipe_details: "/data-pipe-details",
  create_datapipe: "/create-data-pipe",
  aws_oidc_landing: "/aws_oidc_landing",
  privacy_policy: "/privacy-policy",
  signin: "/signin",
};
